"use strict";

exports.__esModule = true;
exports["default"] = {
  noWobble: { stiffness: 170, damping: 26 }, // the default, if nothing provided
  gentle: { stiffness: 120, damping: 14 },
  wobbly: { stiffness: 180, damping: 12 },
  stiff: { stiffness: 210, damping: 20 }
};
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-motion/lib/presets.js
 ** module id = 718
 ** module chunks = 0
 **/